export default "__VITE_PUBLIC_ASSET__fbc92d43__"